import { paginationSearch, searchText } from "@/hooks/use-list-location";
export const lessonCategoriesSearch = (search: Record<string, unknown>) => ({
  q: searchText(search, "q"),
  page: paginationSearch(search).page,
  pageSize: paginationSearch(search).pageSize,
});
